
<template>
  <div>
  <chc-modal ref="makePaymentModal" title="Make Payment">
    <div slot="body">
      <make-payment :charityId="charityId"
                    :towingCompanyId="towingCompanyId"
                        v-on:refresh="refresh"
                        v-on:close="makePaymentHide">
      </make-payment>
    </div>
  </chc-modal>
  <section class="wrapper">
    <chc-tab-control ref="tabControl">
      <chc-tab-pane label="Charity Payables">
        <div class="table-no-search">
          <datatable
            :source='charityPayables'
            :filterable="false"
            :isLoading='isLoading'>
            <datatable-column
              v-for='(column, index) in charityColumns'
              :id='column.id'
              :label='column.label'
              :key='index'
              :sortKey="column.sort"
              >
            </datatable-column>
            <template slot="searchLeft">
            </template>
            <template slot="source_template" slot-scope="data">
              <tr>
                <td>{{ data.row.name }}</td>
                <td>{{ data.row.vehicle_count }}</td>
                <td>{{ data.row.amount_due }}</td>
                <td><a @click="payCharity(data.row.id)">Pay Now</a></td>
              </tr>
            </template>
          </datatable>
        </div>
      </chc-tab-pane>
      <chc-tab-pane label="Towing Payables">
        <div class="table-no-search">
          <datatable
            :source='towingPayables'
            :filterable="false"
            :isLoading='isLoading'>
            <datatable-column
              v-for='(column, index) in towingColumns'
              :id='column.id'
              :label='column.label'
              :key='index'
              :sortKey="column.sort"
              >
            </datatable-column>
            <template slot="searchLeft">
            </template>
            <template slot="source_template" slot-scope="data">
              <tr>
                <td>{{ data.row.name }}</td>
                <td>{{ data.row.vehicle_count }}</td>
                <td>{{ data.row.amount_due }}</td>
                <td><a @click="payTowing(data.row.id)">Pay Now</a></td>
              </tr>
            </template>
          </datatable>
        </div>
      </chc-tab-pane>
    </chc-tab-control>
  </section>
</div>
</template>

<script>
import Datatable from '@/components/Datatables/AppDatatable'
import DatatableColumn from '@/components/Datatables/AppDatatableColumn'
import store from '@/store'
import MakePayment from '@/components/Payables/MakePayment'

export default {
  name: 'Payables',
  mounted () {
    this.refresh()
    if (!this.showCharityPayables) {
      this.$refs.tabControl.selectTab({label: 'Towing Payables'})
    }
  },
  props: {
    showCharityPayables: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      charityColumns: [
        { id: 'name', label: 'Charity' },
        { id: 'vehicle_count', label: 'Vehicle Count' },
        { id: 'amount_due', label: 'Amount Due', sort: 'amount_due_cents' },
        { id: 'pay', label: 'Pay' }
      ],
      towingColumns: [
        { id: 'name', label: 'Towing Company' },
        { id: 'vehicle_count', label: 'Vehicle Count' },
        { id: 'amount_due', label: 'Amount Due', sort: 'amount_due_cents' },
        { id: 'pay', label: 'Pay' }
      ],
      charityPayables: [],
      towingPayables: [],
      isLoading: true,
      charityId: null,
      towingCompanyId: null
    }
  },
  methods: {
    refresh () {
      this.isLoading = true
      Promise.all([
        store.dispatch('syncConstants'),
        store.dispatch('syncSummary'),
        store.functions.payables.charityPayablesTable((response) => { this.charityPayables = response.data }),
        store.functions.payables.towingCompaniesPayablesTable((response) => { this.towingPayables = response.data })
      ]).then(() => {
        this.isLoading = false
      })
    },
    payCharity (charityId) {
      this.charityId = charityId
      this.towingCompanyId = null
      this.makePayment()
    },
    payTowing (towingCompanyId) {
      this.charityId = null
      this.towingCompanyId = towingCompanyId
      this.makePayment()
    },
    makePayment () {
      this.$refs.makePaymentModal.show()
    },
    makePaymentHide () {
      this.$refs.makePaymentModal.hide()
    }
  },
  components: {
    Datatable,
    DatatableColumn,
    MakePayment
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Payables/Payables.vue